import './styles.scss'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import MetaTagsComponent from 'Components/MetaTagsComponent'
import { getLocalTheme, getLocalUserDetails } from 'Utils/LocalStorage_Handler'
import { CoffeeWebContext } from 'Context/CoffeeWebContext'
import { userGuideURLs } from 'Utils/Constants'
import useAnalytics from 'Utils/useAnalytics'
import { SCREEN_EVENTS } from 'Utils/Constants/analyticsEvents'

const UserGuide = () => {
  const { t } = useTranslation()
  const timestamp = new Date().getTime()
  const { isLoading, setLoading } = useContext(CoffeeWebContext)
  const userDetails = getLocalUserDetails()
  const [theme, setTheme] = useState(getLocalTheme())
  const { nonIndianUrl, indianUrl } = userGuideURLs
  const { setScreenLog } = useAnalytics()

  useEffect(() => {
    setLoading(true)
    const userEvent = userDetails ? SCREEN_EVENTS.USER_GUIDE_SCREEN : SCREEN_EVENTS.GUEST_USER_GUIDE_SCREEN

    setScreenLog(userEvent, { subscriptionType: userDetails?.sub?.subTypeName || 'Guest', country: userDetails?.userCountryDetails?.nicename || 'Guest' }) // user-analytics

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleLoad = () => {
    setLoading(false)
  }

  useEffect(() => {
    const updateTheme = () => {
      const theme = getLocalTheme()

      setTheme(theme)
    }

    window.addEventListener('themeChanged', updateTheme)

    return () => {
      window.removeEventListener('themeChanged', updateTheme)
    }
  }, [])

  const iframeSrc = userDetails?.countryId === 102 ? `${indianUrl}?timestamp=${timestamp}&theme=${theme}` : `${nonIndianUrl}?timestamp=${timestamp}&theme=${theme}`

  return (
    <>
      <MetaTagsComponent title={t('USER_GUIDE_TITLE')} description={t('USER_GUIDE_DESCRIPTION')} keywords={t('USER_GUIDE_KEYWORDS')} url="https://coffeeweb.com/user-guide" h1Content={t('USER_GUIDE_H1_CONTENT')} />

      <div className="user-guide-parent" data-testid="user-guide-parent">
        <iframe src={iframeSrc} frameBorder="0" title="User-Guide" width="100%" height="100%" style={{ paddingBottom: '10px', display: isLoading ? 'none' : 'block' }} onLoad={handleLoad}></iframe>
      </div>
    </>
  )
}

export default UserGuide
